<template>
  <v-container 
    grid wrap row no-gutters 
    class="mb-5 mt-5 personal-data-container white" 
  >
    <v-col :cols="12">
      <span class="title">
        Datos Personales
      </span>
    </v-col>
    <v-col :cols="5">
      <v-row>
       <v-col :cols="4">
        <p class="heading">NOMBRE</p>
        <p class="data">{{ user.name }}</p>
       </v-col>
       <v-col :cols="4">
        <p class="heading">APELLIDOS</p>
        <p class="data">{{ user.surname }}</p>
       </v-col>
       <v-col :cols="4">
        <p class="heading">ID ASEGURADO</p>
        <p class="data">{{ user.insurance_id }}</p>
       </v-col>
      </v-row>
    </v-col>
    <v-col :cols="2" />
    <v-col :cols="5">
      <v-row>
       <v-col :cols="4">
        <p class="heading">GÉNERO</p>
        <p class="data">{{ getGenderText(user) }}</p>
       </v-col>
       <v-col :cols="4">
        <p class="heading">EDAD</p>
        <p class="data">{{ user.age }}</p>
       </v-col>
       <v-col :cols="4">
        <p class="heading">FECHA DE NACIMIENTO</p>
        <p class="data">{{ humanReadableDate(user.birth_date) }}</p>
       </v-col>
      </v-row>
    </v-col>

    <v-col :cols="12">
      <p class="heading">TIPO DE EMPLEO</p>
      <p class="data">
        {{ 'employment_type' in user ? user.employment_type.name : '-' }}
      </p>
    </v-col>

    <v-col :cols="12">
      <span class="title">
        Dirección
      </span>
    </v-col>

    <v-col :cols="5">
      <v-row>
       <v-col :cols="3">
        <p class="heading">COLONIA</p>
        <p class="data">{{ user.colonia || '-' }}</p>
       </v-col>
       <v-col :cols="3">
        <p class="heading">MUNICIPIO</p>
        <p class="data">{{ user.city || '-' }}</p>
       </v-col>
       <v-col :cols="3">
        <p class="heading">ESTADO</p>
        <p class="data">{{ user.state || '-' }}</p>
       </v-col>
       <v-col :cols="3">
        <p class="heading">CP</p>
        <p class="data">{{ user.postal_code || '-' }}</p>
       </v-col>
      </v-row>
    </v-col>
    <v-col :cols="7" />

    <v-col :cols="12">
      <span class="title">
        Vivienda
      </span>
    </v-col>

    <v-col :cols="6">
      <v-row>
       <v-col :cols="6">
        <p class="heading">COMPARTE DOMICILLIO</p>
           <p class="data">{{ 'living_types' in user ? user.living_types.map(e => e.name).join(", ") : '-' }}</p>


       </v-col>
       <v-col :cols="6">
        <p class="heading">TIPO DE VIVIENDA</p>
        <p class="data">{{ 'home_type' in user ? user.home_type.name : '-' }}</p>
       </v-col>
      </v-row>
    </v-col>


  </v-container>
</template>

<script>

  import Constants from '../constants'

  export default {
    name: 'PersonalData',

    props: {
      user: {
        type: Object,
        required: true
      },
    },

    data: () => ({
      employmentTypes: Constants.employmentTypes,
      homeBuildingTypes: Constants.homeBuildingTypes
    }),
  }
</script>

<style lang="scss" scoped>


  .title {
     color: #12729a;
     font-weight: 600;
     font-size: 1.2rem;
  }

  .heading {
    color: #555f6b;
    margin-bottom: 0;
  }

  .data {
    font-size: 1.125rem;
    color: #222c38;
    font-weight: 600;
  }

</style>
